import { useState, useEffect, useCallback } from "react";
import type { GalaxyState } from "../types/galaxy";

const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:8787";

export function useGalaxyState(enabled = true) {
  const [galaxyState, setGalaxyState] = useState<GalaxyState | null>(null);
  const [isLoading, setIsLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);

  const fetchState = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/api/galaxy-state`);
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      const data: GalaxyState = await res.json();
      setGalaxyState(data);
    } catch (err) {
      setError(String(err));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) fetchState();
  }, [enabled, fetchState]);

  return {
    galaxyState,
    isLoading,
    error,
    refetch: fetchState,
  };
}
